module.exports = __webpack_public_path__ + "static/media/019.ac85d345.jpg";